import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, withStyles, Paper } from '@material-ui/core'
import { bindActionCreators } from 'redux'
import MenuBar from '../components/header/MenuBar'
import SearchBar from '../components/SearchBar'
import FlashMessage from '../components/FlashMessage'
import Footer from '../components/Footer'
import { trackPage, isUserPremium, isUserLogged } from 'utils'
import arrow from 'images/svg/path-icon.svg'
import starIcon from 'images/svg/star-icon.svg'
import CheckoutForm from 'features/payment/components/CheckoutForm'
import { ROUTES_PATH, MESSAGE } from '../constants'
import { showFlashMessage, showSignInModal } from 'actions'

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  root: {
    display: 'block',
    padding: '0px',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '15px 0px',
    },
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing.unit,
  },
  dealCards: {
    background: 'transparent',
    boxShadow: 'none',
  },
  dealVestorstitle: {
    fontSize: '26px',
    fontWeight: '500',
    letterSpacing: '-0.4px',
    color: '#00bcb5',
    padding: '69px 0 21px',
    margin: '0',
    [theme.breakpoints.down('960')]: {
      padding: '0 0 21px',
    },
  },
  dealvestorsPara: {
    fontSize: '17px',
    color: '#000000',
    paddingBottom: '65px',
    [theme.breakpoints.down('960')]: {
      paddingBottom: '0',
    },
  },
  dealArrowIcon: {
    width: '64px',
    marginLeft: 'auto',
    marginRight: '30px',
    [theme.breakpoints.down('960')]: {
      display: 'none',
    },
  },
  dealPricingModel: {
    fontSize: '17px',
    fontWeight: 500,
    color: '#000000',
    paddingBottom: '42px',
    [theme.breakpoints.down('991')]: {
      paddingBottom: '20px',
    },
  },
  pricingCards: {
    padding: '50px 46px',
    width: '100%',
    boxShadow: '0 7px 23px 0 rgba(0, 0, 0, 0.04)',
    minHeight: '634px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '-78px',
    borderRadius: '0',
    [theme.breakpoints.down('1240')]: {
      padding: '20px 16px',
      minHeight: 'inherit',
    },
    [theme.breakpoints.down('991')]: {
      marginTop: '8px',
    },
  },
  freeCard: {
    borderTop: '#00bcb5 10px solid',
  },
  premiumCard: {
    borderTop: '#ffd200 10px solid',
  },
  pricingTitle: {
    fontSize: '52px',
    letterSpacing: '-0.7px',
    color: '#000000',
    padding: '0 0 30px',
    [theme.breakpoints.down('1240')]: {
      fontSize: '40px',
    },
    [theme.breakpoints.down('767')]: {
      fontSize: '30px',
    },
  },
  pricingContent: {
    minHeight: '105px',
    [theme.breakpoints.down('991')]: {
      minHeight: 'inherit',
    },
  },
  pricingPara: {
    fontSize: '16px',
    lineHeight: 1.35,
    color: '#6e7587',
    padding: '0 5px 41px 0',
  },
  freeTitle: {
    color: '#00bcb5',
  },
  premiumTitle: {
    color: '#ffd200',
  },
  featuresText: {
    fontSize: '20px',
    fontWeight: 500,
    color: '#000000',
    letterSpacing: '-0.3px',
    padding: '0 0 28px',
  },
  featureList: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& li': {
      display: 'flex',
      fontSize: '16px',
      color: '#000',
      marginBottom: '24px',
      '&:before': {
        content: '""',
        display: 'block',
        width: '10px',
        borderRadius: '100%',
        margin: '4px 20px 0 0',
        height: '10px',
        backgroundColor: '#00bcb5',
        flex: 'none',
      },
    },
  },
  premiumList: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& li': {
      display: 'flex',
      alignItems: 'flex-start',
      fontSize: '16px',
      color: '#000',
      marginBottom: '24px',
      '& img': {
        display: 'block',
        width: '22px',
        margin: '0 12px 0 0',
        flex: 'none',
      },
    },
  },
  premiumPrices: {
    display: 'flex',
    alignItems: 'flex-start',
    color: '#6e7587',
    margin: '0 0 38px',
    position: 'relative',
    top: '-4px',
  },
  signText: {
    fontSize: '22px',
    fontWeight: '500',
    letterSpacing: '-0.3px',
  },
  amounText: {
    fontSize: '71px',
    fontWeight: '500',
    lineHeight: '60px',
    letterSpacing: '-1px',
    [theme.breakpoints.down('1240')]: {
      fontSize: '42px',
      lineHeight: '36px',
    },
  },
  monthText: {
    fontSize: '22px',
    fontWeight: '500',
    alignSelf: 'flex-end',
    letterSpacing: '-0.3px',
  },
  pricingButton: {
    width: '100%',
    height: '64px',
    fontWeight: 700,
    textAlign: 'center',
    borderRadius: '6px',
    fontSize: '18px',
    letterSpacing: '0.6px',
    color: '#00bcb5',
    outline: '0',
    textTransform: 'uppercase',
    padding: '19px 0 19px',
    marginTop: 'auto',
    cursor: 'pointer',
    [theme.breakpoints.down('767')]: {
      marginTop: '20px',
    },
  },
  continueBtn: {
    border: 'solid 1.5px #00bcb5',
    backgroundColor: '#fff',
  },
  subscribBtn: {
    border: 'solid 1.5px #00bcb5',
    backgroundColor: '#00bcb5',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  gridList: {
    margin: '0px auto 30px',
    width: 'auto',
    maxWidth: '1240px',
    [theme.breakpoints.down('1241')]: {
      maxWidth: '97%',
    },
  },
  gridFlex: {
    display: 'flex',
  },
})

class PricingPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSettings: false,
      showDetail: false,
    }
  }

  componentDidMount() {
    trackPage(window.location.pathname)
  }

  componentWillMount() {}

  componentDidUpdate(prevProps, prevState) {}

  toggleDetail() {
    if (!isUserLogged(this.props.user)) {
      this.props.showFlashMessage(false, MESSAGE.LOGIN_ERROR_MESSAGE)
    } else {
      const { showDetail } = this.state
      this.setState({
        showDetail: !showDetail,
      })
    }
  }

  routeChange() {
    this.props.history.push(ROUTES_PATH.HOME)
  }

  handleFlashMessageClick = () => {
    this.props.showSignInModal(true)
  }

  render() {
    const { showSettings, showDetail } = this.state
    const { classes, user } = this.props

    return (
      <Grid container>
        {/* <NetworkIssue /> */}
        <Grid item xs={12}>
          <MenuBar hidePremium={true} showSettings={showSettings} setShowSettings={this.setShowSettings} />
        </Grid>
        <Grid item xs={12}>
          <SearchBar withoutSearchBox pricing />
        </Grid>
        <div className={classes.root}>
          <Grid container spacing={24} className={classes.gridList}>
            <Grid item xs={12} sm={12} md={4} className={classes.gridFlex}>
              <Paper className={classes.dealCards}>
                <h1 className={classes.dealVestorstitle}>First Or Free? It’s Your Choice.</h1>
                {/* <div className={classes.dealPricingModel}>Select The Membership Level That’s Best For You.</div> */}
                <div className={classes.dealvestorsPara}>
                  DealVestors offers two levels of memberships: Our paid Premium Membership lets you be among the first to see new listings and great deals on
                  investment properties.
                </div>
                <div className={classes.dealArrowIcon}>
                  <img alt="dealvestor_logo" src={arrow} />
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.gridFlex}>
              <Paper className={`${classes.pricingCards} ${classes.freeCard}`}>
                <div className={`${classes.pricingTitle} ${classes.freeTitle}`}>Standard</div>
                <div className={classes.pricingContent}>
                  <div className={classes.pricingPara}>
                    <span className={classes.amounText}>FREE</span>
                  </div>
                  <div className={classes.pricingPara}>
                    Opening a Standard Membership is easy. Simply fill out the registration form, and we’ll send you an email with the log-in information needed
                    to view our Standard Listings.
                  </div>
                </div>
                <div>
                  <div className={classes.featuresText}>Features</div>
                  <ul className={classes.featureList}>
                    <li>Email notifications of properties that meet your search criteria</li>
                  </ul>
                </div>
                <button className={`${classes.pricingButton} ${classes.continueBtn}`} onClick={() => this.routeChange()}>
                  Continue
                </button>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.gridFlex}>
              <Paper className={`${classes.pricingCards} ${classes.premiumCard}`}>
                <div className={`${classes.pricingTitle} ${classes.premiumTitle}`}>Premium</div>
                <div className={classes.pricingContent}>
                  <div className={classes.premiumPrices}>
                    <span className={classes.signText}>$</span>
                    <span className={classes.amounText}>29.99</span>
                    <span className={classes.monthText}>/month</span>
                  </div>
                  <div className={classes.pricingPara}>
                    For serious real estate investors, a Premium Membership is an investment that can more than pay for itself.
                  </div>
                </div>
                <div>
                  <div className={classes.featuresText}>Features</div>
                  <ul className={classes.premiumList}>
                    <li>
                      <img alt="star" src={starIcon} /> You’ll be among the first to see our newest Premium Listings — putting you in a prime position to secure
                      some of our most promising investment properties.
                    </li>
                  </ul>
                </div>
                <button className={`${classes.pricingButton} ${classes.subscribBtn}`} onClick={() => this.toggleDetail()} disabled={isUserPremium(user)}>
                  {isUserPremium(user) ? 'Already Subscribed' : 'Subscribe'}
                </button>
              </Paper>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container>
              <CheckoutForm open={showDetail} onClose={() => this.toggleDetail()} history={this.props.history} />
            </Grid>
          </Grid>
        </div>
        <Footer />

        <FlashMessage handleClick={this.handleFlashMessageClick} />
      </Grid>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessage,
      showSignInModal,
    },
    dispatch
  )
}

const pricingpage = connect(
  mapStateToProps,
  mapDispatchToProps
)(PricingPage)
export default withStyles(styles)(pricingpage)



// WEBPACK FOOTER //
// ./src/containers/PricingPage.js